var map = {
	"./content_card.png": 1607,
	"./icon_card.png": 3523,
	"./image_card.png": 9575,
	"./name.png": 6282,
	"./name_banner.png": 5437,
	"./plantilla_1.png": 3538,
	"./plantilla_1_1.png": 1590,
	"./plantilla_1_2.png": 3213,
	"./plantilla_1_3.png": 3268,
	"./plantilla_2.png": 6473,
	"./plantilla_2_1.png": 9753,
	"./plantilla_2_2.png": 5746,
	"./plantilla_2_3.png": 9403,
	"./plantilla_3.png": 224,
	"./plantilla_3_1.png": 7400,
	"./plantilla_3_2.png": 4259,
	"./plantilla_4.png": 9247,
	"./plantilla_4_1.png": 4563,
	"./subtitle.png": 1079,
	"./subtitulo_banner.png": 2389,
	"./subtitulo_other.png": 1657,
	"./title.png": 5201,
	"./title_banner.png": 9284,
	"./title_card.png": 948
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3811;